import PropTypes from "prop-types";
import React from "react";
import { toast } from "react-toastify";
import { CoreComponent } from "../../../../../../../../framework/component/index";
import CoreContainer from "../../../../../../../../framework/container/CoreContainer";
import ComponentFactory from "../../../../../../../../framework/factory/ComponentFactory";
import ContainerFactory from "../../../../../../../../framework/factory/ContainerFactory";
import OrderHelper from "../../../../../../../../helper/OrderHelper";

class ShipmentConfirmationComponent extends CoreComponent {
  static className = "ShipmentConfirmationComponent";

  constructor(props) {
    super(props);
    this.state = {
      note: "",
      name: "",
      phone: "",
      useBuyerInfo: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Limpa o formulário quando o modal é aberto
    if (this.props.isOpen && !prevProps.isOpen) {
      this.resetForm();
    }
  }

  resetForm() {
    this.setState({
      note: "",
      name: "",
      phone: "",
      useBuyerInfo: false,
    });
  }

  setNoteText(event) {
    let value = event.target.value;
    let realValue = OrderHelper.stripHtmlTags(value);
    if (value !== realValue) {
      event.target.value = realValue;
    }
    this.setState({ note: realValue });
  }

  setNameText(event) {
    this.setState({ name: event.target.value });
  }

  setPhoneText(event) {
    this.setState({ phone: event.target.value });
  }

  toggleUseBuyerInfo() {
    const { customerData } = this.props;

    this.setState((prevState) => ({
      useBuyerInfo: !prevState.useBuyerInfo,
      name: !prevState.useBuyerInfo ? customerData.fullName : "",
      phone: !prevState.useBuyerInfo ? customerData.telephone : "",
    }));
  }

  ok() {
    const { onClickOk } = this.props;
    const { note, name, phone } = this.state;

    if (!name.trim() || !phone.trim() || !note.trim()) {
      toast.error("Preencha todos os campos obrigatórios: nome, telefone e observação.");
      return;
    }

    let formattedNote = `Nome:\n${name}\n\nTelefone:\n${phone}\n\nObservação:\n${note}`.trim();

    onClickOk(formattedNote);
    this.close();
  }

  close() {
    this.props.onClose();
  }

  template() {
    let display = this.props.isOpen ? "block" : "none";
    const { onClose } = this.props;

    return (
      <div
        className="modal fade in popup-messages"
        role="dialog"
        style={{ display }}
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
            <div className="modal-body">
              {/* Ícone de fechamento no canto superior direito */}
              <button className="close-modal-btn" onClick={onClose}>
                &times;
              </button>

              <h3 className="title">{this.props.t("Kit Removal")}</h3>

              <div className="buyer-checkbox">
                <label>
                  <input
                    type="checkbox"
                    id="buyer-info"
                    checked={this.state.useBuyerInfo}
                    onChange={() => this.toggleUseBuyerInfo()}
                  />
                  <span className="custom-checkbox"></span>
                  {this.props.t("Retirado pelo próprio comprador")}
                </label>
              </div>

              <input
                type="text"
                className="form-control"
                placeholder={this.props.t("Nome:")}
                value={this.state.name}
                onChange={(event) => this.setNameText(event)}
              />

              <input
                type="text"
                className="form-control"
                placeholder={this.props.t("Telefone:")}
                value={this.state.phone}
                onChange={(event) => this.setPhoneText(event)}
              />

              <textarea
                className="form-control refund-confirmation-text"
                placeholder={this.props.t("Observação")}
                value={this.state.note}
                onChange={(event) => this.setNoteText(event)}
              />
            </div>
            <div className="modal-footer actions-2column">
              <button className="btn btn-default" onClick={() => this.ok()}>
                {this.props.t("Take Shipment")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShipmentConfirmationComponent.propTypes = {
  onClickOk: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  orderItems: PropTypes.array.isRequired,
  customerData: PropTypes.shape({
    fullName: PropTypes.string,
    telephone: PropTypes.string,
  }),
};

class ShipmentConfirmationContainer extends CoreContainer {
  static className = "ShipmentConfirmationContainer";
}

export default ContainerFactory.get(ShipmentConfirmationContainer).withRouter(
  ComponentFactory.get(ShipmentConfirmationComponent)
);


// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/component/order/order-detail/create-shipment/popup/ShipmentConfirmation.js